import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import Home from './Home';
import GithubCallback from './GithubCallback';  // Import the callback component

// A mock function to check if the user is authenticated
const isAuthenticated = () => {
  return localStorage.getItem('authToken') !== null;
};

function App() {
  return (
    <Router basename="/oxbo-translation-app">
      <Routes>
        {/* Define your routes here */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/github-callback" element={<GithubCallback />} />  {/* GitHub Callback */}
        <Route path="/" element={<Home />} />

        {/* Protected route for home, redirects to login if not authenticated */}
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Home />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;